import * as React from 'react';
const SvgClipPaths = () => (
// Ensure it displays but isn't visible
React.createElement("div", { style: { position: 'absolute', zIndex: -999, top: -999, left: -999 } },
    React.createElement("svg", { viewBox: "0 0 39 30" },
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "wave_svg__wave-a" },
                React.createElement("path", { fill: "#fff", stroke: "#fff", d: "M0 0h8v30H0z" })),
            React.createElement("clipPath", { id: "wave_svg__wave-b" },
                React.createElement("path", { fill: "#fff", stroke: "#fff", d: "M-.091 0h7.5v30h-7.5z" })),
            React.createElement("clipPath", { id: "wave_svg__wave-c" },
                React.createElement("path", { fill: "#fff", stroke: "#fff", d: "M-2 0H8v30H-2z" })),
            React.createElement("clipPath", { id: "wave_svg__wave-d" },
                React.createElement("path", { fill: "#fff", stroke: "#fff", d: "M4 0h6.5v30H4z" })))),
    React.createElement("svg", { viewBox: "0 0 1920 239.5" },
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "wave_oncology_svg__clippath" },
                React.createElement("rect", { className: "cls-1", width: "1920", height: "239.5" })))),
    React.createElement("svg", { viewBox: "0 0 1920 239.5" },
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "wave_radiology_svg__clippath" },
                React.createElement("rect", { className: "cls-1", width: "1920", height: "239.5" }))))));
export default SvgClipPaths;
